import React from "react";
import PropTypes from "prop-types";
import { loadModules } from "@esri/react-arcgis";
import { fullscreenAltIcon, fullscreenExitAltIcon } from "commons/icons";
import ProgressBar from "../../components/progress-bar/progress-bar.component";
import "./mapa-geografico.component.scss";

const options = { url: "https://js.arcgis.com/3.29/" };
const BASE_LAYER_URL =
  "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer";
const REGIONS_LAYER_URL =
  "https://pifa.oefa.gob.pe/arcgis/rest/services/PORTAL/LIMITES_FISCALIZABLES_OEFA/MapServer/0";
class MapaGeografico extends React.Component {
  static propTypes = {
    onClickFocusRegion: PropTypes.bool,
    onRegionClick: PropTypes.func,
    areaFocalizada: PropTypes.string,
    scope: PropTypes.object
  };
  static defaultProps = {
    onClickFocusRegion: true
  };
  static contextTypes = {
    router: PropTypes.object
  };
  static instanceCount = 0;
  static modulesLoadFailed = false;
  constructor(props) {
    super(props);
    var me = this;
    MapaGeografico.instanceCount++;
    me.instanceId = MapaGeografico.instanceCount;
    me.state = {
      modulesLoaded: false,
      modulesLoadFailed: false,
      areaFocalizada: props.areaFocalizada,
      fullscreen: false
    };
    me.loadArcgisModules();
  }
  loadArcgisModules() {
    var me = this;
    me.esriModules = {};
    loadModules(
      [
        "esri",
        "esri/map",
        "esri/graphic",
        "esri/tasks/query",
        "esri/layers/MapImageLayer",
        "esri/layers/FeatureLayer",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/renderers/SimpleRenderer",
        "esri/Color"
      ],
      options
    ).then(
      ([
        esri,
        Map,
        Graphic,
        Query,
        DynamicLayer,
        FeatureLayer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        SimpleRenderer,
        Color
      ]) => {
        // Guardar modulos Arcgis cargados en una variable
        me.esriModules = {
          esri,
          Map,
          Graphic,
          Query,
          DynamicLayer,
          FeatureLayer,
          SimpleFillSymbol,
          SimpleLineSymbol,
          SimpleRenderer,
          Color
        };
        me.afterArcgisModulesLoad();
      },
      // Error en carga de modulos
      error => {
        MapaGeografico.modulesLoadFailed = true;
        me.setState({ modulesLoadFailed: true });
        // eslint-disable-next-line no-console
      }
    );
  }
  afterArcgisModulesLoad() {
    let me = this;
    me.setState({ modulesLoaded: true }, () => {
      me.createMap();
    });
  }
  createMap() {
    var me = this,
      scope = me.scope || me,
      props = me.props;
    const { Map } = me.esriModules;
    let map = new Map(me.getMapContainerId(), {
      basemap: "gray",
      zoom: 6,
      minZoom: me.props.zoom?me.props.zoom:3,
      maxZoom: 19,
      center: [-75.074387, -10.39665],
      showLabels: true
    });
    me.map = map;
    map.on("load", function () {
      // Indicador de carga de modulos
      me.mapLoaded = true;
      // Capa Base
      me.addBaseLayer();
      // Habilitar evento del mouse
      map.graphics.enableMouseEvents();
      // Capa de regiones
      me._addRegionsLayer();
      // Limpiar Gráficos
      map.graphics.on("mouse-out", function () {
        map.graphics.clear();
      });
      //-- Region Click
      if (props.onClickFocusRegion) {
        map.graphics.on("click", function (e) {
          me.showRegion(e.graphic.attributes.IDDPTO);
        });
      }
      if (props.onRegionClick) {
        map.graphics.on("click", function (e) {
          props.onRegionClick.call(scope, e.graphic.attributes.IDDPTO);
        });
      }
      // Vista inicial
      me.showRegion(me.props.areaFocalizada);
    });
  }
  addBaseLayer() {
    const { DynamicLayer } = this.esriModules;
    let layer = new DynamicLayer(BASE_LAYER_URL, {
      id: "red",
      opacity: 0.2,
      showAttribution: false
    });
    this.map.addLayer(layer);
  }
  _addRegionsLayer() {
    var me = this;
    const {
      FeatureLayer,
      SimpleRenderer,
      SimpleFillSymbol,
      SimpleLineSymbol,
      Color
    } = me.esriModules;
    let symbol = new SimpleFillSymbol(
      SimpleFillSymbol.STYLE_SOLID,
      new SimpleLineSymbol(
        SimpleLineSymbol.STYLE_SOLID,
        new Color([121, "085", "061", 0.25]),
        1
      ),
      new Color([125, 125, 125, 0])
    );
    let sfs = new SimpleFillSymbol(
      SimpleFillSymbol.STYLE_SOLID,
      new SimpleLineSymbol(
        SimpleLineSymbol.STYLE_SOLID,
        new Color([52, 148, 232]),
        2
      ),
      new Color([52, 148, 232, 0.25])
    );

    let regionsLayer = new FeatureLayer(REGIONS_LAYER_URL, {
      id: "REGIONS",
      mode: FeatureLayer.MODE_AUTO,
      showAttribution: false,
      outFields: ["*"]
    });
    regionsLayer.setRenderer(new SimpleRenderer(symbol));
    regionsLayer.setSelectionSymbol(sfs);
    regionsLayer.on("mouse-over", function (e) {
      me.onGraphicMouseOver(e, "1");
    });
    me.map.addLayer(regionsLayer);
    me.regionsLayer = regionsLayer;
  }
  showPais() { }
  componentDidUpdate() {
    if (this.mapLoaded) {
      this.showRegion(this.props.areaFocalizada);
    }
  }
  showRegion(regionID) {
    var me = this;
    if (!regionID || regionID === "00") {
      me.regionsLayer.clearSelection();
      me.map.centerAndZoom([-75.074387, -10.39665], 5);
    }
    const { esri, Query } = me.esriModules;
    let query = new Query();
    query.where = "IDDPTO=" + regionID;

    me.regionsLayer.selectFeatures(
      query,
      esri.layers.FeatureLayer.SELECTION_NEW,
      function (features) {
        if (features[0]) {
          me.map.setExtent(features[0].geometry.getExtent().expand(1.5));
        }
      }
    );
  }

  onGraphicMouseOver(e, idlyr) {
    const {
      Graphic,
      SimpleFillSymbol,
      SimpleLineSymbol,
      Color
    } = this.esriModules;
    e.graphic.attributes["id_att"] = idlyr;
    let highlightSymbol = new SimpleFillSymbol(
      SimpleFillSymbol.STYLE_SOLID,
      new SimpleLineSymbol(
        SimpleLineSymbol.STYLE_SOLID,
        new Color([255, 0, 0]),
        1.2
      ),
      new Color([125, 125, 125, 0.25])
    );
    var highlightGraphic = new Graphic(
      e.graphic.geometry,
      highlightSymbol,
      e.graphic.attributes
    );
    this.map.graphics.add(highlightGraphic);
  }
  render() {
    let me = this;
    const { modulesLoaded, modulesLoadFailed } = me.state;
    if (modulesLoaded && !modulesLoadFailed) {
      return <div className="mapa-geografico" id={me.getMapContainerId()} />;
    }
    // Si los modulos de Arcgis no cargarón correctamente
    if (modulesLoadFailed || MapaGeografico.modulesLoadFailed) {
      return (
        <div className="mapa-geografico">
          <div>&nbsp;</div>
          <div className="m-3 alert alert-info sinia-message" role="alert">
            Lo sentimos el modulo de mapas geográficos no pudo ser cargado.
            <br />
            Por favor intente volver a cargar la página.
          </div>
        </div>
      );
    }
    // Cargando módulos Arcgis
    return (
      <div className="mapa-geografico">
        <div>&nbsp;</div>
        <ProgressBar active={true} style={{ margin: "150px 16px 0 16px" }} />
      </div>
    );
  }
  /**
   * El id del div que es asignada por la renderización del mapa
   */
  getMapContainerId() {
    return "map-geo-" + this.instanceId;
  }
  /**
   * In dev.
   */
  renderToolbar() {
    let me = this;
    const { fullscreen } = this.state;
    return (
      <div className="mapa-geografico__toolbar">
        <button
          title={
            fullscreen
              ? "Salir modo pantalla completa"
              : "Ver en pantalla completa"
          }
          dangerouslySetInnerHTML={{
            __html: fullscreen ? fullscreenExitAltIcon : fullscreenAltIcon
          }}
          onClick={me.fullScreenToggle.bind(me)}
        />
      </div>
    );
  }
  fullScreenToggle() {
    let me = this;
    let isFullScreen = me.state.fullscreen;
    document.body.className = isFullScreen ? "" : "no-scroll";
    me.setState({ fullscreen: !isFullScreen }, () => {
      //me.createMap();
      //me.map.centerAndZoom(MAP_INITIAL_CONFIG.center);
    });
  }
}
export default MapaGeografico;
